/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { toastEmmit } from "../../../../Helper/Toastr";
// import { ImageURL } from "../../../../Environment/Environment";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";
import {
  showSuccessAlert,
  showErrorAlert,
  // showDeleteConfirmation,
} from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";

export default function Print() {
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [loading, setLoading] = useState(true);
  const [PrintList, setPrintList] = useState();
  const [selectedData, setSelectedData] = useState();
  const [submitLoader, setsubmitLoader] = useState(false);
  const { type } = useParams();

  useEffect(() => {
    getPrintList();
  }, [type]);

  const getPrintList = () => {
    setLoading(true);

    GetService(`${API_URL.GET_PLEXI_LIST}?type=${type}&type1=admin`).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          setPrintList(res.data.data);
          //   SetTotalPageCount(res.data.totalPages);
          //   SetTotalCount(res.data.totalItems);
          //   setCount(res.data.currentPage * param.limit);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const [error, setError] = useState(false);

  const [Size, setSize] = useState("");
  const [Price, setPrice] = useState("");
  const [status, setstatus] = useState("");

  useEffect(() => {
    setSize(selectedData?.size);
    setPrice(selectedData?.price);
    setstatus(selectedData?.status);
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (!Price || !status) {
      setError(true);
      return;
    }

    setsubmitLoader(true);
    const data = {
      price: Price,
      status: status,
      id: selectedData?.id
    };

    PostService(API_URL.UPDATE_PLEXI_WOOD_ARTTRAY_CANVAS, data).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getPrintList);
          resetFunc();
          document.getElementById("closeEditModal").click();
          // getPrintList();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL?.UPDATE_PLEXI_WOOD_ARTTRAY_CANVAS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(`Status ${status === "active" ? "inactive" : "active"} successfully`, getPrintList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  function resetFunc() {
    setSelectedData();
    setSize("");
    setPrice("");
    setstatus("");
    setError(false);
    setsubmitLoader(false);
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  function dataobj(data) {
    console.log(data);
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="text-capitalize">{type} List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">{type} list</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body" style={{minHeight:'350px'}}>
                  {/* <div className="row">
                    <div className="col-md-4 offset-md-8  p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div> */}

                  {
                    <div className="table-responsive mt-3">
                      {!loading && (
                        <table className="table table-hover table-bordered table-striped">
                          <thead>
                            <tr>
                              <th className="text-center">S.No</th>
                              <th className="text-center"> Size</th>
                              <th className="text-center">Price ($)</th>
                              <th className="text-center">Status</th>
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {PrintList?.map((data, i) => (
                              <tr key={i}>
                                <td className="text-center">
                                  {i + S_No_Count + 1}
                                </td>
                                <td className="text-center">
                                  {data?.size ? data?.size : "N/A"}
                                </td>
                                <td className="text-center">
                                  {data?.price ? data?.price : "N/A"}
                                </td>

                                <td className="text-center">
                                  <label
                                    className={
                                      data?.status === "active"
                                        ? "badge badge-success"
                                        : "badge badge-danger"
                                    }
                                  >
                                    {" "}
                                    {data?.status}
                                  </label>
                                </td>
                                <td className="text-center">
                                  <span className="toggle-switch">
                                    <Switch
                                      checked={data?.status === "active"}
                                      onChange={() => {
                                        changeStatus(
                                          data?.id,
                                          data?.status
                                        );
                                      }}
                                      size="small"
                                      color="primary" // You can customize the color
                                      inputProps={{
                                        "aria-label": "toggle switch",
                                      }}
                                    />
                                  </span>
                                  <span
                                    title="Edit"
                                    style={{ cursor: "pointer" }}
                                    className="mx-2"
                                    data-toggle="modal"
                                    data-target="#EditModal"
                                    onClick={() => {
                                      setSelectedData(data);
                                      dataobj(data);
                                    }}
                                  >
                                    <i className="text-dark fas fa-pen"></i>{" "}
                                  </span>
                                </td>
                              </tr>
                            ))}
                            {PrintList && PrintList.length === 0 && (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  <h6 className="p-3"> No Data Found </h6>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                      {loading ? (
                        <div className="LoaderSpinner">
                          <MoonLoader
                            color={"#003bff"}
                            loading={loading}
                            speedMultiplier={0.6}
                            size={50}
                          />
                          <div>Loading... Please wait.</div>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* 
                      <div className="mt-4">
                        <Pagination
                          counting={S_No_Count}
                          totaldata={TotalCount}
                          pagecount={TotalPageCount}
                          onChangePage={handlePageClick}
                          activePage={currentPage}
                        />
                      </div> */}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4
                className="modal-title text-capitalize"
                id="exampleModalLabel"
              >
                Edit {type}
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Size</label>
                  <input
                    type="text"
                    name="name"
                    value={Size}
                    className="form-control"
                    readOnly
                  />
                </div>

                <div className="form-group">
                  <label>Price ($)</label>
                  <input
                    className="form-control"
                    placeholder="Enter Price"
                    value={Price}
                    onChange={(e) => setPrice(e.target.value)}
                  />

                  {error && !Price && (
                    <div className="error">Price is required</div>
                  )}
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Status</label>
                      <select
                        className="form-control"
                        value={status}
                        onChange={(e) => setstatus(e.target.value)}
                      >
                        <option value="" selected default hidden>
                          Select
                        </option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>

                      {error && !status && (
                        <div className="error">Status is required</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
